import { GetAll } from '../tag/index.mjs';

var GetByEntity;
(function (GetByEntity) {
    GetByEntity.responseSchema = GetAll.responseSchema;
})(GetByEntity || (GetByEntity = {}));

export { GetByEntity };
